import { Navigate, useLocation } from "react-router-dom";
import { useProfileData } from "hooks/ProfileDetails";
import DrivingRange from "pages/Driving/DrivingRange";
import Myprofile from "pages/My-profile/My-profile";
import MapView from "pages/MapView/MapView";
import RangeInformation from "pages/Driving/RangeInformation";
import EditRangeInformation from "pages/Driving/EditRangeInfo";
import HeatMapList from "pages/HeatMapList/HeatMapList";
import HeatMapEditor from "pages/HeatMapEditor/HeatMapEditor";
import CourseMapList from "pages/CourseMapList/CourseMapList";
import CourseInformation from "pages/CourseMapList/CourseInformation";
import EditCourseInfo from "pages/CourseMapList/EditCourseInfo";
import CourseMappingScorecardDetails from "components/CourseMappingScorecardDetails/CourseMappingScorecardDetails";

export function PrivateRoute({ children, requiredModule }) {
	const location = useLocation();
	const token =
		localStorage.getItem("secretKey") || sessionStorage.getItem("secretKey");
	const userProfileData = useProfileData();
	const userDetails = JSON.parse(localStorage.getItem("profile_data"));

	if (!token) {
		return <Navigate to="/" />;
	}

	if (
		requiredModule &&
		userProfileData.profile_information_status !== "loading" &&
		!userDetails?.moduleArray?.includes(requiredModule)
	) {
		return <Navigate to="/NoAccess" state={{ from: location }} replace />;
	}

	return children;
}

export const privateRoutes = [
	{
		route: "/coursemap",
		component: <CourseMapList />,
		requiredModule: 16,
	},
	{
		route: "/drivingrange",
		component: <DrivingRange />,
		requiredModule: 22,
	},
	{
		route: "/heatmap",
		component: <HeatMapList />,
		requiredModule: 23,
	},
	{
		route: "/heatmapeditor",
		component: <HeatMapEditor />,
		requiredModule: 23,
	},
	{
		route: "/myprofile",
		component: <Myprofile />,
	},
	{
		route: "/mapview/:type",
		component: <MapView />,
		requiredModule: 16,
	},
	{
		route: "/rangeinformation",
		component: <RangeInformation />,
		requiredModule: 22,
	},
	{
		route: "/editRangeInformation/:id",
		component: <EditRangeInformation />,
		requiredModule: 22,
	},
	{
		route: "/courseinformation",
		component: <CourseInformation />,
		requiredModule: 16,
	},
	{
		route: "/editCourseInformation/:id",
		component: <EditCourseInfo />,
		requiredModule: 16,
	},
	{
		route: "/scoreDetails/:id",
		component: <CourseMappingScorecardDetails />,
		requiredModule: 16,
	},
];
